import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const getAuth = (state) => state.usersReducer;
export default function RedirectUser() {
  const location = useLocation();
  const { initURL, authUser } = useSelector(getAuth);
  if(location?.pathname === "/" && authUser !== null){
    return <Navigate to={"/home/dashboard"} />;
  }
}
//To be worked on
  /* if (location.pathname === "/") {
    if (authUser === null) {
      return <Navigate to={"/"} />;
    } 
      else if (initURL === "" || initURL === "/" || initURL === "/login") {
      return <Navigate to={"/home/dashboard"} />;
    } else {
      return <Navigate to={initURL} />;
    }
  }
}  */